// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const AvailabilityConfig = () => (function(config: any) {
   const {
      site
   } = config

   return {
      libHash: config.info.libhash,
      showCallNums: site.show_callnums,
      showDeweys: site.show_deweys,
      showDetailCallNums: site.show_quicklook_callnums,
      showDetailDeweys: site.show_quicklook_deweys,
      showCallNumsOnFail: site.show_availability_callnums,
      showDatabaseInfo: typeof site.show_availability_database_info === 'undefined' ? false : site.show_availability_database_info, // default off, but can be turned on by setting
      showDeweysOnFail: site.show_availability_deweys,
      hasRTA: config.info?.dbs?.some((element: any) => element.availabilityLink)
   }
})

angular.module('summonApp.factories.configs')
   .factory('availabilityConfig', AvailabilityConfig)
